<template>
  <div class="commerce-agent-notifications main">
    <div class="wrapper no-scrollbar">
      <h1 class="header" @click="$emit('close')">
        <i class="fa fa-chevron-left" style="padding: 0 6px" />
        Notifications
      </h1>

      <div
        v-if="telegramInviteLink"
        class="notification is-info"
        @click="joinTelegramGroup"
      >
        <p class="subtitle">Join Notifications Group</p>
        <p><i class="fa fa-link" />&nbsp; Click to join notifications group</p>
        <div class="has-text-right">
          <a class="button">
            Get Notifications&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>
      <div
        v-if="!$store.state.notificationToken"
        class="notification is-danger"
        @click="sendTestNotification"
      >
        <p class="subtitle">Notifications Blocked</p>
        <p>
          <i class="fa fa-exclamation-triangle" />&nbsp; Please check app
          notification permissions
        </p>
        <p>Enable notifications in your phone's system settings.</p>
        <p>
          Make sure notifications are allowed for the App as well as Chrome (or
          your default browser).
        </p>
        <div
          v-if="$store.getters.getNotificationToken"
          class="has-text-link"
          style="background-color: #eee; padding: 3px 6px; border-radius: 3px"
        >
          <i class="fa fa-info-circle" />
          This account has other registered devices that may be receiving push
          notifications.
        </div>
      </div>

      <div class="notification is-primary" @click="sendTestNotification">
        <p class="subtitle">Send Test Notification</p>
        <p style="margin-bottom: 10px">📣 Send a notification to this device</p>
        <p>If you don't receive it within a minute:</p>
        <p>
          1. Check your system settings and chrome browser settings (or default
          browser).
        </p>
        <p>
          2. After you've allowed notifications, restart the app and try again.
        </p>
        <div class="has-text-right">
          <a class="button">
            Test Notification&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>

      <div class="notification is-dark">
        <!-- <span class="is-pulled-right">
          <span class="link">Copy</span>&nbsp;<i class="fa fa-copy"
        /></span> -->
        <div class="subtitle">System Info</div>
        <p>
          <code>Notification</code>
          <span v-if="$store.state.notification"
            >{{ $store.state.notification.created_at }}:
            {{ $store.state.notification.title }}</span
          >
          <span v-else>NONE</span>
        </p>
        <p><code>User</code> {{ $store.state.user.name }}</p>
        <p><code>Mobile</code> {{ $store.state.user.phone_number }}</p>
        <p><code>UUID</code> {{ shortenString($store.state.uuid.uuid, 20) }}</p>
        <p><code>Token</code>{{ shortToken }}</p>
        <div v-if="$store.state.device">
          <p><code>OS</code> {{ $store.state.device.os }}</p>
          <p><code>Browser</code> {{ $store.state.device.browser }}</p>
          <p><code>UA</code> {{ $store.state.device.userAgent }}</p>
          <p><code>PWA</code> {{ $store.state.device.pwa }}</p>
          <p><code>Webview</code> {{ $store.state.device.webview }}</p>
          <p><code>iOS App</code>{{ $store.state.device.iOSApp }}</p>
          <p><code>URL</code> {{ $store.state.device.start_url }}</p>
        </div>
      </div>

      <div class="notification is-warning" @click="help">
        <p class="subtitle">Need Help?</p>
        <p style="margin-bottom: 10px">
          Send us a chat message and we'll get back to you ASAP.
        </p>
        <div class="has-text-right">
          <!-- <a class="button" href="https://m.me/tukapp" target="_blank"> -->
          <a class="button">
            Get Help&nbsp;
            <i class="fa fa-chevron-right" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sounds } from "../functions.js";

export default {
  name: "CommerceAgentNotifications",
  components: {},
  props: {
    workflow: Object,
  },
  data() {
    return {};
  },
  computed: {
    telegramInviteLink() {
      return this.workflow.data.telegram_invite_link;
    },
    shortToken() {
      if (!this.$store.state.notificationToken) return "NONE";
      return this.shortenString(this.$store.state.notificationToken, 20);
    },
  },
  mounted() {
    var msg = "Send a test notification";
    this.$swal(msg).then(() => this.sendTestNotification());
  },
  methods: {
    help() {
      var msg = `Opening chat support <i class='fa fa-spinner fa-spin'></i>`;
      this.warningToast(msg);
      this.contactFBMessengerSupport();
    },
    joinTelegramGroup() {
      window.open(this.telegramInviteLink, "_blank");
    },
    sendTestNotification() {
      this.requestPushNotificationPermission();
      this.log("check_notifications", "commerce_agent");
      var msg = `Sending notification to this device <i class='fa fa-spinner fa-spin'></i>`;
      this.infoToast(msg);
      sounds("navigate1");
      this.sendPushNotification("Hi from TUK 👍🏼", this.userID());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  max-width: 600px;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 21;
  backdrop-filter: blur(3px);
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.header {
  font-size: 1.3em;
  font-weight: 450;
  margin-top: 4px;
  margin-bottom: 12px;
}
.subtitle {
  opacity: 0.7;
  font-weight: 450;
  margin-bottom: 14px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
p {
  margin-bottom: 10px;
}
.is-dark p {
  margin-bottom: 2px;
}
.notification {
  padding: 12px 16px;
  margin-bottom: 10px;
}
code {
  border-radius: 2px;
  padding: 0 2px;
  background-color: #bbb;
  color: black;
  margin-right: 4px;
}
</style>